/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      username
      email
      role
      plan
      profile {
        id
        userProfileId
        companyName
        logo
        description
        services
        location
        contactWhatsApp
        isVerified
        createdAt
        updatedAt
        owner
        __typename
      }
      leads {
        nextToken
        __typename
      }
      vehicles {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileId
      owner
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      username
      email
      role
      plan
      profile {
        id
        userProfileId
        companyName
        logo
        description
        services
        location
        contactWhatsApp
        isVerified
        createdAt
        updatedAt
        owner
        __typename
      }
      leads {
        nextToken
        __typename
      }
      vehicles {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileId
      owner
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      username
      email
      role
      plan
      profile {
        id
        userProfileId
        companyName
        logo
        description
        services
        location
        contactWhatsApp
        isVerified
        createdAt
        updatedAt
        owner
        __typename
      }
      leads {
        nextToken
        __typename
      }
      vehicles {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      userProfileId
      owner
      __typename
    }
  }
`;
export const createProfile = /* GraphQL */ `
  mutation CreateProfile(
    $input: CreateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    createProfile(input: $input, condition: $condition) {
      id
      userProfileId
      companyName
      logo
      description
      services
      location
      contactWhatsApp
      isVerified
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateProfile = /* GraphQL */ `
  mutation UpdateProfile(
    $input: UpdateProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    updateProfile(input: $input, condition: $condition) {
      id
      userProfileId
      companyName
      logo
      description
      services
      location
      contactWhatsApp
      isVerified
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteProfile = /* GraphQL */ `
  mutation DeleteProfile(
    $input: DeleteProfileInput!
    $condition: ModelProfileConditionInput
  ) {
    deleteProfile(input: $input, condition: $condition) {
      id
      userProfileId
      companyName
      logo
      description
      services
      location
      contactWhatsApp
      isVerified
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createVehicle = /* GraphQL */ `
  mutation CreateVehicle(
    $input: CreateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    createVehicle(input: $input, condition: $condition) {
      id
      vehicleOwnerId
      year
      make
      model
      titleStatus
      mileage
      price
      isFeatured
      isCashDeal
      status
      description
      imageKey
      videoURL
      allImageKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateVehicle = /* GraphQL */ `
  mutation UpdateVehicle(
    $input: UpdateVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    updateVehicle(input: $input, condition: $condition) {
      id
      vehicleOwnerId
      year
      make
      model
      titleStatus
      mileage
      price
      isFeatured
      isCashDeal
      status
      description
      imageKey
      videoURL
      allImageKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteVehicle = /* GraphQL */ `
  mutation DeleteVehicle(
    $input: DeleteVehicleInput!
    $condition: ModelVehicleConditionInput
  ) {
    deleteVehicle(input: $input, condition: $condition) {
      id
      vehicleOwnerId
      year
      make
      model
      titleStatus
      mileage
      price
      isFeatured
      isCashDeal
      status
      description
      imageKey
      videoURL
      allImageKeys
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLead = /* GraphQL */ `
  mutation CreateLead(
    $input: CreateLeadInput!
    $condition: ModelLeadConditionInput
  ) {
    createLead(input: $input, condition: $condition) {
      id
      leadOwnerId
      type
      sourceURL
      customerName
      customerPhone
      message
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateLead = /* GraphQL */ `
  mutation UpdateLead(
    $input: UpdateLeadInput!
    $condition: ModelLeadConditionInput
  ) {
    updateLead(input: $input, condition: $condition) {
      id
      leadOwnerId
      type
      sourceURL
      customerName
      customerPhone
      message
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteLead = /* GraphQL */ `
  mutation DeleteLead(
    $input: DeleteLeadInput!
    $condition: ModelLeadConditionInput
  ) {
    deleteLead(input: $input, condition: $condition) {
      id
      leadOwnerId
      type
      sourceURL
      customerName
      customerPhone
      message
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
